import paymentRequirements from "@/feature/PaymentRequirements/router/payment-requirements";

export default paymentRequirements;